module.exports = __webpack_public_path__ + "static/media/under16-gift-banner-desktop.7a8f2817.jpg";